import type { CheckoutEvent, CheckoutState } from './checkout';
import { checkoutSelector, dispatchCheckoutSelector, useTradeModuleStore } from './store';

/** Single reducer facade over the module store's checkout slice. */
export function useCheckout(): [CheckoutState, (event: CheckoutEvent) => void] {
  const state = useTradeModuleStore(checkoutSelector);
  const dispatch = useTradeModuleStore(dispatchCheckoutSelector);
  return [state, dispatch];
}
